import { createFileRoute } from "@tanstack/react-router";
import { ServersScreen } from "../-servers/ServersScreen";

export const Route = createFileRoute("/admin/servers/")({
  staticData: { title: "Servers" },
  component: ServersScreen,
});
